import moment from "moment";
import React from "react";
import { memo, useState } from "react";
import { Div, Img, Txt } from "Components/GenericView";

const ManagePackages: React.FunctionComponent<any> = (props) => {
  const { walletPackages, setPackageDetail } = props;
  const [collapseActive, setCollapseActive] = useState(true);
  const [collapseInActive, setCollapseInActive] = useState(true);
  const activePackages =
    walletPackages?.filter((pack: any) => !pack.is_expired) ?? [];
  const inActivePackages =
    walletPackages?.filter((pack: any) => pack.is_expired) ?? [];

  const getExpiryDateBlockColor = (nestedPackage: any) => {
    if (moment(nestedPackage.expiry_date).diff(moment(), "days") < 7)
      return "rgb(255, 136, 136,0.2)";
    return "rgb(224, 240, 242,0.6)";
  };
  const getExpiryBarColor = (nestedPackage: any) => {
    if (nestedPackage.remaining_duration <= 2) return "#FF8888";
    return Number(nestedPackage.remaining_duration) <
      nestedPackage.total_duration * 0.2
      ? "#FF8888"
      : "#32bdc7";
  };
  return (
    <Div className="package-popup-scroll">
      {activePackages.length > 0 && (
        <Div color="#22234E" margin="14px">
          <Div
            className="justify-between mp-border-b"
            pointer
            pb={9}
            h
            vc
            onClick={() => setCollapseActive(!collapseActive)}
          >
            <Div>
              <Txt bg="#7ED321" br={8} width={10} height={10} inline />
              <Txt ml={10} inline>
                Active Packages
              </Txt>
            </Div>
            <Img
              src={
                collapseActive
                  ? "/self-serve/tab-arrowdown@3x.png"
                  : "/self-serve/tab-arrowup@3x.png"
              }
              width="8.51px"
              height={4}
            />
          </Div>
          {collapseActive &&
            activePackages.map((pkg: any, index: number) => (
              <Div key={index}>
                <Div h vc mt={20}>
                  {pkg.icon_url.map((icon: string) => (
                    <Img key={icon} src={icon} size={32} />
                  ))}
                  <Txt ml={8} color="#757588" fs={14}>
                    {pkg.title}
                  </Txt>
                </Div>
                <Div mt={10} h className="wrap">
                  {pkg?.packages?.map((nestedPackage: any, ind: number) => (
                    <Div
                      key={ind}
                      bc="#ECECEC"
                      br={20}
                      textAlign="center"
                      p="10px 17px"
                      width={188}
                      className="package"
                      mr={6}
                      mb={10}
                      pointer
                      onClick={() =>
                        setPackageDetail({
                          ...nestedPackage,
                          isActive: !pkg.is_expired,
                          mainTitle: pkg.title,
                        })
                      }
                    >
                      <Txt color="#22234E" fs={12}>
                        <b>{nestedPackage.title}</b>
                      </Txt>
                      <Txt color="#9191A2" fs={10}>
                        ID: {nestedPackage.purchased_id}
                      </Txt>
                      <Div
                        className="hv-progress-bar"
                        margin={"8px 0px 3px 0px"}
                      >
                        <div
                          style={{
                            width:
                              (Number(nestedPackage.remaining_duration) /
                                nestedPackage.total_duration) *
                                100 +
                              "%",
                            background: getExpiryBarColor(nestedPackage),
                          }}
                          className="hv-progress-bar-filled"
                        ></div>
                      </Div>
                      <Txt
                        color={
                          getExpiryBarColor(nestedPackage) === "#FF8888"
                            ? "#FF8888"
                            : "#636475"
                        }
                        fs={11}
                      >
                        {nestedPackage.remaining_desc}
                      </Txt>
                      <Div className="dashed-hr" margin="7px 0px" />
                      <Div
                        bg={getExpiryDateBlockColor(nestedPackage)}
                        p={5}
                        textAlign="center"
                      >
                        <Txt color="#8B8C9C" fs={11}>
                          Expiry:{" "}
                          {moment(nestedPackage.expiry_date).format("D MMM")}
                        </Txt>
                      </Div>
                    </Div>
                  ))}
                </Div>
              </Div>
            ))}
        </Div>
      )}
      {inActivePackages.length > 0 && (
        <Div color="#22234E" margin="14px" mt={23}>
          <Div
            className="justify-between mp-border-b"
            pointer
            pb={9}
            h
            vc
            onClick={() => setCollapseInActive(!collapseInActive)}
          >
            <Div>
              <Txt bg="#C9C9C9" br={8} width={10} height={10} inline />
              <Txt ml={10} inline>
                Expired Packages
              </Txt>
            </Div>
            <Img
              src={
                collapseInActive
                  ? "/self-serve/tab-arrowdown@3x.png"
                  : "/self-serve/tab-arrowup@3x.png"
              }
              width="8.51px"
              height={4}
            />
          </Div>
          {collapseInActive &&
            inActivePackages.map((pkg: any, index: number) => (
              <Div key={index}>
                <Div h vc mt={20}>
                  {pkg.icon_url.map((icon: string) => (
                    <Img key={icon} src={icon} size={32} />
                  ))}
                  <Txt ml={8} color="#757588" fs={14}>
                    {pkg.title}
                  </Txt>
                </Div>
                <Div mt={10} h className="wrap">
                  {pkg?.packages?.map((nestedPackage: any, ind: number) => (
                    <Div
                      key={ind}
                      bc="#ECECEC"
                      br={20}
                      textAlign="center"
                      p="10px 17px"
                      width={188}
                      className="package"
                      mr={6}
                      mb={10}
                      pointer
                      onClick={() =>
                        setPackageDetail({
                          ...nestedPackage,
                          isActive: !pkg.is_expired,
                          mainTitle: pkg.title,
                        })
                      }
                    >
                      <Txt color="#22234E" fs={12}>
                        <b>{nestedPackage.title}</b>
                      </Txt>
                      <Txt color="#9191A2" fs={10}>
                        ID: {nestedPackage.purchased_id}
                      </Txt>
                      <Div
                        className="hv-progress-bar"
                        margin={"8px 0px 3px 0px"}
                      >
                        <div
                          style={{
                            width:
                              (Number(nestedPackage.remaining_duration) /
                                nestedPackage.total_duration) *
                                100 +
                              "%",
                            background: "#C9C9C9",
                          }}
                          className="hv-progress-bar-filled"
                        ></div>
                      </Div>
                      <Txt color="#636475" fs={11}>
                        {nestedPackage.remaining_desc}
                      </Txt>
                      <Div className="dashed-hr" margin="7px 0px" />
                      <Div bg="rgb(232, 232, 232,0.6)" p={5} textAlign="center">
                        <Txt color="#8B8C9C" fs={11}>
                          {" "}
                          Expiry:{" "}
                          {moment(nestedPackage.expiry_date).format("D MMM")}
                        </Txt>
                      </Div>
                    </Div>
                  ))}
                </Div>
              </Div>
            ))}
        </Div>
      )}
    </Div>
  );
};

export default memo(ManagePackages);
